import { InAppState } from "../base/InAppState";
import template from './LogsTemplate.html';     // Normal user template

export class LogsState extends InAppState
{
    static ROUTE = '/logs';
    static ID = 'admin-logs';

    async enter()
    {
    }

    async exit()
    {
    }

    getContentHeaderData()
    {
        return {
            title: 'Logs',
            breadcrumb: [ 'Admin', 'Logs' ]
        };
    }
}
